import React from 'react';
import { CreateButton, ExportButton, TopToolbar } from 'react-admin';

export default ({
                    basePath,
                    bulkActionButtons,
                    currentSort,
                    displayedFilters,
                    exporter,
                    filterValues,
                    filters,
                    hasCreate,
                    onUnselectItems,
                    permissions,
                    resource,
                    selectedIds,
                    showFilter,
                    total,
                }) => (
    <TopToolbar>
        {bulkActionButtons && React.cloneElement(bulkActionButtons, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {hasCreate && permissions && permissions.indexOf('PostDevice') >= 0 && permissions.indexOf('DeviceSubscriptionTypePostpaid') >= 0 && <CreateButton basePath={basePath} />}
        {exporter !== false && (
            <ExportButton
                disabled={total === 0}
                resource={resource}
                sort={currentSort}
                filter={filterValues}
                exporter={exporter}
            />
        )}
    </TopToolbar>
);
